import Vue from 'vue'
import Vuex from 'vuex'

import simulator from './module-simulator'
import { createHistoryPlugin } from './module-simulator/lib/history'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    simulator
  },
  plugins: [createHistoryPlugin('simulator')]
})
